
import styles from './Characteristics.module.scss'
import {DetailedHTMLProps, HTMLAttributes, useState} from "react";
import {PageProps} from "@/types";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import Button from "@/Atoms/Input/Button";
import {Characteristic} from "@/types/Characteristic";
import characteristicTypes from "@/Organisms/Modals/Characteristics";


interface CharacteristicsProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  characteristics: Characteristic[]
}

export default function Characteristics({className, characteristics}: CharacteristicsProps) {
  const [open, setOpen] = useState(false)


  const list = open ? characteristics : characteristics.slice(0, 4)
  return <div className={styles.characteristics}>
    <div className={styles.items}>
      {list && list.map(({type, value}) => {
        const characteristic = characteristicTypes.find(c => c.id === type || c.fallbacks?.includes(type))
        const {faIcon, name}  = characteristic ? characteristic : {faIcon: '', name: ''}

        return <div key={type} className={styles.item}>
          <div className={styles.icon}>
            <i className={faIcon}></i>
          </div>
          <div className={styles.content}>
            <div className={styles.title}>{name}</div>
            <div className={styles.text}>{value}</div>
          </div>
        </div>
      })}
    </div>
    <Button outlined onClick={() => setOpen(!open)} >Lees {open ? 'minder' : 'meer'}</Button>
  </div>
}
